export const NotFound = () => {
    return (
        <>
            <div style={{ fontSize: '35px', fontWeight: 500,height:'100vh',display:'flex',justifyContent:'center',alignItems:'center' }}>
                Coming Soon!
            </div></>
    )
}
